import { type ErrorResponse } from './errors';

class HttpResponse<T> {
  public result: T;

  public error: number | ErrorResponse | undefined;

  public constructor(result: T, error?: number | ErrorResponse) {
    this.result = result;
    if (error) {
      this.error = error;
    }
  }
}

export default HttpResponse;
